import { useCallback, useMemo } from 'react';
import useToggle from './use-toggle.esm.js';

function useBoolean() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useToggle = useToggle(defaultValue),
    state = _useToggle.state,
    toggle = _useToggle.toggle,
    refState = _useToggle.refState;
  var on = useCallback(function () {
    return toggle(true);
  }, [toggle]);
  var off = useCallback(function () {
    return toggle(false);
  }, [toggle]);
  var setActive = useMemo(function () {
    return {
      toggle: toggle,
      on: on,
      off: off,
      refState: refState
    };
  }, [off, on, refState, toggle]);
  return [state, setActive];
}

export { useBoolean as default };
//# sourceMappingURL=use-boolean.esm.js.map
